module.exports = __webpack_public_path__ + "static/coretto@2x-77fa506c1cada91f2be9e5b65a069a7d.png";